package com.merkost.handpass.api.dto.admin

import com.merkost.handpass.api.dto.report.UserReportResponse
import com.merkost.handpass.api.dto.user.ProfileResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminUserDetail(
    val profile: ProfileResponse,
    val listings: List<AdminListingListItem>,
    @SerialName("reports_against") val reportsAgainst: List<UserReportResponse>,
    @SerialName("moderation_history") val moderationHistory: List<ModerationLogEntry>
)
